import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

import { RoutePaths } from '../constants';

export const useNavigateBack = (fallbackPath = RoutePaths.Main) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handler = useCallback(() => {
        if (location.key === 'default') {
            navigate(fallbackPath);

            return;
        }

        navigate(-1);
    }, [location, navigate, fallbackPath]);

    return handler;
};
